import type { GridInterface } from '@ad-lucy/context/adData';

import { defineGrid } from './defineGrid';

export const grid1x0 = (): GridInterface[] =>
  defineGrid('1:0', [
    {
      name: 'All',
      rows: [
        {
          columns: [
            {
              tileId: 0,
            },
          ],
        },
      ],
    },
  ]);
